export default "__VITE_PUBLIC_ASSET__f340d0c6__"